<template>
	<div class="catfoot">
		<transition-group
			:enter-class="catfoot_box_enterClass"
			enter-active-class="catfoot-active"
			leave-active-class="catfoot-active"
			:leave-to-class="catfoot_box_leaveClass"
			class="catfoot-container"
			tag="div"
		>
			<div v-if="showIndex == 10" key="catfoot_2025_9" class="catfoot_s catfoot_2025_9">
				<div class="decoration"></div>
				<div class="boundary"></div>
				<img
					class="catfood_logos catfood_logos202410"
					src="../assets/images/catfood2025/top-logo.png"
					alt
				/>

				<div class="catfoot_size">
					<img
						class="ranking"
						src="../assets/images/catfood2025/top202509.png"
						alt=""
					/>
					<img
						class="Player"
						src="../assets/images/catfood2025/player202509.png"
						alt=""
					/>
				</div>

<!--				<div class="catfoot_size ">-->
<!--					<span>ABOUT CATFOOD BOWL - MAJOR #BATTLE OF KIRIN S3</span>-->

<!--					<p>-->
<!--						Catfood Bowl - Major #Battle of Kirin S3 is an official tournament hosted by Yostar which invites top class players from the Catfood Bowl - Minor to have top-level matches.-->
<!--					</p>-->
<!--					<p>-->
<!--						The Catfood Bowl - Major #Battle of Kirin Season 3 will be held in September. The 4 top class players from Catfood Bowl - Minor from 2024 to 2025 will show their strength to take not only the podium, but also the tournament trophy, a limited title, and other fabulous prizes.-->
<!--					</p>-->
<!--					<p>-->
<!--						Who will become the final champion of the Catfood Bowl - Major #Battle of Kirin Season 3? Let's wait and see!-->
<!--					</p>-->
<!--				</div>-->
			</div>
			<div v-if="showIndex == 9" key="catfoot_2025_1" class="catfoot_s catfoot_2025_1">
				<div class="decoration"></div>
				<div class="boundary"></div>
				<img
					class="catfood_logos catfood_logos202501"
					src="../assets/images/catfood2025/202501.png"
					alt
				/>
				<div class="catfoot_size">
					<img
						class="ranking"
						src="../assets/images/catfood2025/top202501.png"
						alt=""
					/>
					<img
						class="Player"
						src="../assets/images/catfood2025/player202501.png"
						alt=""
					/>
				</div>
			</div>
			<div v-if="showIndex == 8" key="catfoot_2024_10" class="catfoot_s catfoot_2024_10">
				<div class="decoration"></div>
				<div class="boundary"></div>
				<img
					class="catfood_logos catfood_logos202410"
					src="../assets/images/catfood2024/top-logo.png"
					alt
				/>
				<div class="catfoot_size">
					<img
						class="ranking"
						src="../assets/images/catfood/TOP4202410.png"
						alt=""
					/>
					<img
						class="Player"
						src="../assets/images/catfood/Player202410.png"
						alt=""
					/>
				</div>
<!--				<div class="catfoot_size">-->
<!--					<span>ABOUT CATFOOD BOWL - MAJOR #BATTLE OF KIRIN S2</span>-->

<!--					<p>-->
<!--						Catfood Bowl - Major #Battle of Kirin S2 is an official tournament hosted by Yostar which invites top class players from the Catfood Bowl - Minor to have top-level matches.-->
<!--					</p>-->
<!--					<p>-->
<!--						The Catfood Bowl - Major #Battle of Kirin Season 2 will be held in October. The 4 top class players from Catfood Bowl - Minor from 2022 to 2023 will show their strength to take not only the podium, but also the tournament trophy, a limited title, and other fabulous prizes.-->
<!--					</p>-->
<!--					<p>-->
<!--						Who will become the final champion of the Catfood Bowl - Major #Battle of Kirin Season 2? Let's wait and see!-->
<!--					</p>-->
<!--				</div>-->
			</div>
			<div
				v-if="showIndex == 7"
				key="catfoot_2024_1"
				class="catfoot_s catfoot_2024_1"
			>
				<div class="decoration"></div>
				<div class="boundary"></div>
				<img
					class="catfood_logos catfood_logos2024"
					src="../assets/images/catfood2022/catFoodLogo_2024.png"
					alt
				/>

				<div class="catfoot_size">
					<img
						class="ranking"
						src="../assets/images/catfood/TOP42024.png"
						alt=""
					/>
					<img
						class="Player"
						src="../assets/images/catfood/Player2024.png"
						alt=""
					/>
				</div>
			</div>
			<div
				v-if="showIndex == 6"
				key="catfoot_2023_6"
				class="catfoot_s catfoot_2023_6"
			>
				<div class="decoration"></div>
				<div class="boundary"></div>
				<img
					class="catfood_logos catfood_logos2023"
					src="../assets/images/catfood2022/catFoodLogo_2023.png"
					alt
				/>

				<div class="catfoot_size">
					<img
						class="ranking"
						src="../assets/images/catfood/TOP42023.png"
						alt=""
					/>
					<img
						class="Player"
						src="../assets/images/catfood/Player2023.png"
						alt=""
					/>
				</div>
			</div>
			<div
				v-if="showIndex == 5"
				key="catfoot_2022_6"
				class="catfoot_s catfoot_2022_6"
			>
				<div class="decoration"></div>
				<div class="boundary"></div>
				<img
					class="catfood_logos catfood_logos2022"
					src="../assets/images/catfood/catfood_logo.png"
					alt
				/>

				<div class="catfoot_size">
					<img
						class="ranking"
						src="../assets/images/catfood/TOP42022.png"
						alt=""
					/>
					<img
						class="Player"
						src="../assets/images/catfood/Player2022.png"
						alt=""
					/>
				</div>
			</div>
			<div
				v-if="showIndex == 4"
				key="catfoot_2021_6"
				class="catfoot_s catfoot_2021_6"
			>
				<div class="decoration"></div>
				<div class="boundary"></div>
				<img
					class="catfood_kirin_logos"
					src="../assets/images/catfood/kirin_logo.png"
					alt
				/>

				<div class="catfoot_size">
					<img
						class="ranking"
						src="../assets/images/catfood/TOP4202106.png"
						alt=""
					/>
					<img
						class="Player"
						src="../assets/images/catfood/Player202106.png"
						alt=""
					/>
				</div>
			</div>
			<!-- <div v-if="showIndex == 3" key="catfoot_2021_1" class="catfoot_s catfoot_2021_1">
                <div class="decoration"></div>
                <div class="boundary"></div>
                <img class="catfood_logos" src="../assets/images/catfood/catfood_logo.png" alt />

                <div class="catfoot_size">
                    <span>About Catfood Bowl Tournament:</span>
                    <p>
                        Catfood Bowl Tournament is an official tournament hosted by Yostar
                        which was first held in May 2019.
                    </p>
                    <p>
                        The 2021 Catfood Bowl - Minor #OxYearPowerCup will be held in
                        1/7-1/27. There will be intense matches
                        <br />among the finalists to compete for the tournament trophy, a
                        limited portrait frame, priority pass to advanced <br />tournaments,
                        and various in-game rewards.
                    </p>
                    <p>
                        Catfood Bowl - Minor #OxYearPowerCup will refer to the WRC rules and
                        adopt a strict elimination format,
                        <br />which emphasizes more on the technique of a Jyanshi.<br />Who
                        will become the champion of the Catfood Bowl - Minor
                        #OxYearPowerCup? Let's wait and see!
                    </p>
                </div>
            </div> -->
			<div
				v-if="showIndex == 3"
				key="catfoot_2021_1"
				class="catfoot_s catfoot_2021_1"
			>
				<div class="decoration"></div>
				<div class="boundary"></div>
				<img
					class="catfood_logos catfood_logos2021"
					src="../assets/images/catfood/catfood_logo2021.png"
					alt
				/>

				<div class="catfoot_size">
					<img
						class="ranking"
						src="../assets/images/catfood/TOP42021.png"
						alt=""
					/>
					<img
						class="Player"
						src="../assets/images/catfood/Player2021.png"
						alt=""
					/>
				</div>
			</div>
			<div
				v-if="showIndex == 2"
				key="catfoot_2020"
				class="catfoot_s catfoot_2020"
			>
				<div class="decoration"></div>
				<div class="boundary"></div>
				<img
					class="catfood_logos catfood_logos2020"
					src="../assets/images/catfood/catfood_logo2020.png"
					alt
				/>

				<div class="catfoot_size">
					<img
						class="ranking"
						src="../assets/images/catfood/TOP42020.png"
						alt=""
					/>
					<img
						class="Player"
						src="../assets/images/catfood/Player2020.png"
						alt=""
					/>
				</div>
			</div>
			<div
				v-if="showIndex == 1"
				key="catfoot_2019"
				class="catfoot_s catfoot_2019"
			>
				<div class="decoration"></div>
				<div class="boundary"></div>
				<img
					class="catfood_logos catfood_logos2019"
					src="../assets/images/catfood/catfood_logo2019.png"
					alt
				/>

				<div class="catfoot_size">
					<img
						class="ranking"
						src="../assets/images/catfood/TOP42019.png"
						alt=""
					/>
					<img
						class="Player"
						src="../assets/images/catfood/Player2019.png"
						alt=""
					/>
				</div>
			</div>
		</transition-group>

		<div class="scroll">
			<div class="timerShaft" v-if="!noChange">
				<!-- <div>
					<div v-if="!First" class="timers timerFirstly" @click="Firsts()">
					</div>
					<img v-if="First" class="timerimgs timerimgsOne" src="../assets/images/catfood/2021.png" alt="" />
				</div>

				<div>
					<div v-if="!Second" class="timers timerSecond" @click="Seconds()">
						<p>2020</p>
					</div>
					<img v-if="Second" class="timerimgs timerimgstwo" src="../assets/images/catfood/2020.png" alt="" />
				</div>

				<div>
					<div v-if="!third" class="timers timerthirdly" @click="thirds()">
						<p>2019</p>
					</div>
					<img v-if="third" class="timerimgs timerimgsthree" src="../assets/images/catfood/2019.png" alt="" />
				</div> -->
				<div
					v-for="(item, index) in timeLine"
					:key="index"
					class="timerShaft-item"
					:class="{ active: item.isCurrent }"
				>
					<div
						class="timers"
						v-show="!item.isCurrent"
						@click="changeIndex(item, index)"
					></div>
					<img
						v-show="item.isCurrent"
						class="timerimgs"
						src="../assets/images/catfood/catfoot.png"
						alt=""
					/>
					<p class="text">{{ item.text }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "catfoot",
	props: {
		tabId: {
			type: String || Number,
			default: 1
		},
		noChange: {
			type: Boolean,
			default: false
		}
	},
	components: {},
	data: () => ({
		show: false,
		// First: false, //2021年展示
		// Second: false, //2020年展示
		// third: false, //2019年展示

		curkanban_dir: "",

		showIndex: 10,
		timeLine: [
			{
				tabId: 10,
				text: "2025.9",
				isCurrent: true
			},
			{
				tabId: 9,
				text: "2025.1",
				isCurrent: false
			},
			{
				tabId: 8,
				text: "2024.10",
				isCurrent: false
			},
			{
				tabId: 7,
				text: "2024.1",
				isCurrent: false
			},
			{
				tabId: 6,
				text: "2023.1",
				isCurrent: false
			},
			{
				tabId: 5,
				text: "2022.1",
				isCurrent: false
			},
			{
				tabId: 4,
				text: "2021.6",
				isCurrent: false
			},
			{
				tabId: 3,
				text: "2021.1",
				isCurrent: false
			},
			{
				tabId: 2,
				text: "2020",
				isCurrent: false
			},
			{
				tabId: 1,
				text: "2019",
				isCurrent: false
			}
		]
	}),
	created() {
		this.showIndex = this.tabId;
		this.timeLine.forEach(e => {
			e.tabId == this.tabId
				? (e.isCurrent = true)
				: (e.isCurrent = false);
		});
	},
	mounted() {},
	watch: {
		showIndex(val, oldVal) {
			if (val > oldVal) {
				this.curkanban_dir = "next";
			} else {
				this.curkanban_dir = "pre";
			}
		}
	},
	computed: {
		catfoot_box_enterClass() {
			// return "catfoot_next-enter";
			return `${
				this.curkanban_dir === "next"
					? "catfoot_next-enter"
					: "catfoot_pre-enter"
			}`;
		},
		catfoot_box_leaveClass() {
			// return "catfoot_next-leave-to";
			return `${
				this.curkanban_dir === "next"
					? "catfoot_next-leave-to"
					: "catfoot_pre-leave-to"
			}`;
		}
	},
	methods: {
		changeIndex(item, index) {
			this.showIndex = item.tabId;
			this.timeLine.forEach(e => {
				e.isCurrent = false;
			});
			this.timeLine[index].isCurrent = true;
		},
		//2021年默认
		// Firsts() {
		// 	this.First = true;
		// 	this.Second = false;
		// 	this.third = false;
		// 	this.showIndex = 0;
		// },
		//2020年默认
		// Seconds() {
		// 	this.First = false;
		// 	this.Second = true;
		// 	this.third = false;
		// 	this.showIndex = 1;
		// },
		//2019年默认
		// thirds() {
		// 	this.showIndex = 2;
		// 	this.First = false;
		// 	this.Second = false;
		// 	this.third = true;
		// }
	}
};
</script>

<style lang="scss" scoped>
.catfoot {
	font-family: "hyyr";
	background: rgba(0, 0, 0, 0.75);
	position: relative;
	height: pxTorem(320px);
	overflow: hidden;
	position: relative;

	.catfoot-container {
		height: 100%;
		width: 100%;
		// position: absolute;
		// width: 100%;
		// bottom: 0;
		// left: 0;
	}
	.catfoot-active {
		transition: all 1s ease;
	}
	.catfoot_next-enter {
		transform: translateX(-100%);
	}
	.catfoot_next-leave-to {
		transform: translateX(100%);
	}
	.catfoot_pre-enter {
		transform: translateX(100%);
	}
	.catfoot_pre-leave-to {
		transform: translateX(-100%);
	}

	.catfoot_2021 {
		opacity: 1;
	}
	@keyframes bounce-in {
		0% {
			transform: translateX(100%);
		}
		50% {
			transform: translateX(0%);
		}
		100% {
			transform: translateX(0%);
		}
	}

	.catfoot_s {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		.boundary {
			top: 27%;
			left: 45.4%;
			border-top: 1px solid white;
			border-bottom: 1px solid white;
			width: 39%;
			height: pxTorem(3px);
			position: absolute;
			@media screen and (max-width: 600px) {
				left: 41%;
				height: MpxTorem(2px);
				width: 50%;
			}
		}
	}
	.timerShaft {
		top: 80%;
		left: 50%;
		transform: translateX(-50%);
		position: absolute;
		//width: 60%;
		max-width: 90%;
		height: pxTorem(5px);
		border: 1px solid #797979;
		display: flex;
		justify-content: center;
		border-radius: pxTorem(3px);
		&-item {
			display: flex;
			flex-direction: column;
			text-align: center;
			align-items: center;
			font-size: pxTorem(15px);
			min-width: 100px;
			margin: 0 pxTorem(10px);
			&:last-child {
				margin-right: pxTorem(40px);
			}
		}
		@media screen and (max-width: 600px) {
			left: 50%;
			top: 86%;
			transform: translate(-50%);
			height: MpxTorem(2px);
		}
		.active {
			.text {
				color: #fff;
				font-size: 20px;
			}
		}
		.timerimgs {
			top: -230%;
			position: absolute;
			z-index: 5;
			width: pxTorem(30px);
		}
		.text {
			font-family: Microsoft Sans Serif;
			position: absolute;
			font-size: pxTorem(14.83px);
			top: pxTorem(20px);
			color: #6f6e6e;
		}
		// .timerimgsOne {
		//     left: 8.6%;
		// }
		// .timerimgstwo {
		//     left: 23.6%;
		//     @media screen and (max-width: 600px) {
		//         left: 46.3%;
		//     }
		// }
		// .timerimgsthree {
		//     left: 38.6%;
		//     @media screen and (max-width: 600px) {
		//         left: 85%;
		//     }
		// }
		.timers {
			text-align: center;
			border: 1px solid white;
			border-radius: pxTorem(6px);
			height: pxTorem(12px);
			width: pxTorem(12px);
			background: #000;
			position: absolute;
			top: -75%;
			cursor: pointer;
			p {
				color: white;
				font-size: pxTorem(12px);
				position: absolute;
				top: 140%;
				right: -75%;
			}
		}
		.timerFirstly {
			left: 10%;
			@media screen and (max-width: 600px) {
				left: 10%;
			}
		}
		.timerSecond {
			left: 25%;
			@media screen and (max-width: 600px) {
				left: 48%;
			}
		}
		.timerthirdly {
			left: 40%;
			@media screen and (max-width: 600px) {
				left: 87%;
			}
		}
	}

	.decoration {
		top: 16%;
		left: 43%;
		position: absolute;
		background: white;
		width: 1px;
		height: 58%;
		@media screen and (max-width: 600px) {
			top: 18%;
			left: 39%;
			height: 80%;
		}
	}

	.catfood_logos {
		left: pxTorem(170px);
		top: 21%;
		position: absolute;
		width: pxTorem(294px);
	}
	.catfood_kirin_logos {
		position: absolute;
		left: pxTorem(270px);
		top: 6%;
		width: pxTorem(200px);
	}
	.catfood_logos2021 {
		width: pxTorem(314px);
	}
	.catfood_logos2020 {
		width: pxTorem(314px);
	}
	.catfood_logos2019 {
		width: pxTorem(260px);
	}
	.catfood_logos202410 {
		left: pxTorem(255px);
		top: 10%;
		width: pxTorem(215px);
	}
	.catfood_logos202501 {
		width: pxTorem(314px);
	}
	.catfoot_size {
		height: pxTorem(236px);
		text-align: left;
		// box-sizing: border-box;
		padding-top: pxTorem(28px);
		margin-left: 45.45%;
		padding-bottom: pxTorem(18px);
		color: white;
		font-size: pxTorem(10px);
		position: relative;
		max-width: 40%;
		.ranking {
			position: absolute;
			top: 11%;
			height: pxTorem(30px);
		}
		.Player {
			width: pxTorem(392px);
			position: absolute;
			top: 37%;
			left: 3.5%;
		}
		span {
			line-height: pxTorem(56px);
			font-size: pxTorem(16px);
		}
		p {
			line-height: pxTorem(15px);
			margin-bottom: pxTorem(10px);
		}
	}
}
@media screen and (max-width: 600px) {
	.catfoot {
		height: MpxTorem(200px);
		.catfood_logos {
			left: MpxTorem(12px);
			top: 42%;
			position: absolute;
			width: MpxTorem(120px);
		}
		.catfood_logos202410 {
			top: 15%;
		}

		.catfood_kirin_logos {
			position: absolute;
			left: MpxTorem(12px);
			top: 32%;
			width: MpxTorem(120px);
		}
		.catfoot_size {
			// box-sizing: border-box;
			padding-top: MpxTorem(18px);
			margin-left: 41%;
			color: white;
			font-size: MpxTorem(7px);
			max-width: fit-content;
			.ranking {
				height: MpxTorem(16px);
			}
			span {
				// margin-bottom: pxTorem(36px);
				line-height: MpxTorem(40px);
				font-size: MpxTorem(7px);
			}
			p {
				margin-bottom: pxTorem(10px);
				line-height: 1.0
			}
		}
		.scroll {
			position: absolute;
			width: 100%;
			overflow: auto;
			top: 75%;
			left: 0;
			height: MpxTorem(55px);
			box-sizing: border-box;
			padding: MpxTorem(10px) MpxTorem(15px);
		}
		.timerShaft {
			top: 0;
			left: 0;
			position: relative;
			width: MpxTorem(550px);
			margin: 0 MpxTorem(25px);
			max-width: inherit;
			transform: none;
			&-item {
				display: flex;
				flex-direction: column;
				text-align: center;
				align-items: center;
				font-size: pxTorem(15px);
				min-width: 40px;
				margin: 0 MpxTorem(10px);
				&:last-child {
					margin-right: MpxTorem(20px);
				}
			}
			.timers {
				text-align: center;
				border: 1px solid white;
				border-radius: pxTorem(6px);
				height: pxTorem(12px);
				width: pxTorem(12px);
				background: #000;
				position: absolute;
				top: -155%;
				cursor: pointer;
				p {
					color: white;
					font-size: pxTorem(12px);
					position: absolute;
					top: 140%;
					right: -75%;
				}
			}
			.timerimgs {
				top: pxTorem(-16px);
				position: absolute;
				z-index: 5;
				width: pxTorem(30px);
			}
		}
	}
	.catfoot_2024_10 .catfoot_size {padding-top: MpxTorem(10px)}
}
.catfoot_2025_9 .catfoot_size {padding-top: pxTorem(20px)}

</style>
